import { api } from "./api";

const SESSION_KEY = "bm_session_id";

function ensureSession() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid =
      (crypto?.randomUUID && crypto.randomUUID()) ||
      `sess_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function device() {
  const ua = navigator.userAgent || "";
  if (/mobile/i.test(ua)) return "mobile";
  if (/tablet|ipad/i.test(ua)) return "tablet";
  return "desktop";
}

export async function trackEvent(eventType, extra = {}) {
  try {
    const sid = ensureSession();
    await api.post("/visitor-events", {
      event_type: eventType,
      path: window.location.pathname,
      referrer: document.referrer || null,
      device: device(),
      session_id: sid,
      ...extra,
    });
  } catch (_) {
    /* fire-and-forget */
  }
}

export function trackPageView() {
  return trackEvent("page_view");
}

export function trackArtworkClick(artworkId) {
  return trackEvent("artwork_click", { artwork_id: artworkId });
}

export function trackCtaClick(section) {
  return trackEvent("cta_click", { section });
}

export function trackSectionView(section) {
  return trackEvent("section_view", { section });
}
